import { createUseStyles } from 'react-jss';

export const useAmbassadorMobileStyles = createUseStyles({
  '@global': {
    '.slick-slider': {
      width: '100%',
      Height: '236px',
    },

    '.slick-slide': {
      transform: 'scale(0.8)',
      transition: 'all .3s ease-in-out',
      Height: '186px',
    },

    '.center .slick-center': {
      transform: 'scale(1)',
      Height: '236px',
    },
  },
  ambassadorCarousel: {
    marginTop: '10px',
  },
});
